export class SyncException {
  private _message: string;
  private _code: number;

  constructor(
    _message: string = null,
    _code: number = null
  ) {
    this._message = _message;
    this._code = _code;
  }

  set message(message: string) {
    this._message = message;
  }

  set code(code: number) {
    this._code = code;
  }

  get message(): string {
    return this._message;
  }

  get code(): number {
    return this._code;
  }
}
